import React from "react";
import { useSelector } from "react-redux";

import AccountDetailsCard from "./card/accountDetailsCard";
import { ReactComponent as CompanyIcon } from "../../images/company.svg";
import { ReactComponent as CheckIcon } from "../../images/check.svg";
import { ReactComponent as CrossIcon } from "../../images/cross_red.svg";
import Tag from "../../ui-components/molecules/tag/tag";
import { TagColor } from "../../app/data/common/tagColor";

import { accountDetailsSelector } from "../../slices/account-details/accountDetailsSlice";

const AccountDetailsCompanyInfo: React.FC<{}> = () => {
  const { companyInfo } = useSelector(accountDetailsSelector);

  const companyInfoRows = [
    {
      label: "Account Number",
      value: companyInfo?.accountNumber
    },
    {
      label: "Attention Name",
      value: companyInfo?.attentionName
    },
    {
      label: "Zip-code",
      value: companyInfo?.zip,
    },
    {
      label: "City / State",
      value: `${companyInfo?.city} / ${companyInfo?.state}`,
    },
    {
      label: "Address",
      value: companyInfo?.address,
    },    
  ];

  const companyContactsRows = [
    {
      label: "Suite / Building",
      value: companyInfo?.additionalAddressLine,
    },
    {
      label: "Main phone",
      value: companyInfo?.phone?.formatPhone()
    },
    {
      label: "Fax",
      value: companyInfo?.fax,
    },
    {
      label: "Paypoint",
      value: companyInfo?.paypointNumber,
    },
    {
      label: "Website",
      value: companyInfo?.website,
    },
  ];

  const companyRolesRows = [
    {
      label: "Payor",
      value: companyInfo?.payor,
    },
    {
      label: "Shipper",
      value: companyInfo?.shipper,
    },
    // {
    //   label: "Consignee",
    //   value: companyInfo?.consignee,
    // },
    // {
    //   label: "Distributor",
    //   value: companyInfo?.distributor,
    // },    
  ];

  return (
    <AccountDetailsCard
      title="Company Info"
      icon={<CompanyIcon />}
      link={companyInfo?.payor ? <Tag mods={{color: TagColor.GREEN, uppercase: true}}>Paypoint</Tag> : undefined}
    >
      <div className="account-details__card__content-block">
        {companyInfoRows.map((row, index) => (
          <div key={index} className="account-details__card__row account-details__card__content-row">
            <span className="account-details__card__label">{row.label}:</span>
            <span>{row.value || "-"}</span>
          </div>
        ))}
      </div>

      <div className="account-details__card__content-block">
        {companyContactsRows.map((row, index) => (
          <div key={index} className="account-details__card__row account-details__card__content-row">
            <span className="account-details__card__label">{row.label}:</span>
            <span>{row.value || "-"}</span>
          </div>
        ))}
      </div>      

      <div className="account-details__card__divider"/>

      <div className="account-details__card__content-block">
        {companyRolesRows.map((row, index) => (
          <div key={index} className="account-details__card__row account-details__card__content-row">
            <span className="account-details__card__label">{row.label}:</span>
            {row.value ? <CheckIcon style={{ color: "#14870A" }} /> : <CrossIcon style={{ color: "#E82A2B" }} />}
          </div>
        ))}
      </div>
    </AccountDetailsCard>
  );
};

export default AccountDetailsCompanyInfo;